@app.directive 'csLinkToCommentsShortcode', ->
  restrict: 'E'
  scope: {}
  bindToController:
    'text': '@'
  controllerAs: 'csLinkToCommentsShortcode'
  template: "<a href='#discussion' ng-if='csLinkToCommentsShortcode.currentUser'>{{csLinkToCommentsShortcode.text}}</a>"

  controller: ($state) ->
    @currentUser = $state.currentUser
    this
